import {Location} from '@angular/common';
import {inject, Injectable} from '@angular/core';
import {OX_KEYS} from '@ox/config';
import {RebuttalInfo, ShopState} from '@ox/typings';
import {SessionStorageService} from '@ox/utils';
import {BehaviorSubject} from 'rxjs';


@Injectable()
export class ShopService {
    private location = inject(Location);
    private sessionStorage = inject(SessionStorageService);

    constructor() {
        this.init();
    }

    private _billingType = new BehaviorSubject<string>('');
    public billingType$ = this._billingType.asObservable();

    get billingType() {
        return this._billingType.getValue();
    }

    set billingType(val: string) {
        this._billingType.next(val);
    }

    private _planCodes = new BehaviorSubject<string[]>([]);
    public planCodes$ = this._planCodes.asObservable();

    get planCodes() {
        return this._planCodes.getValue();
    }

    set planCodes(val: string[]) {
        this._planCodes.next(val);
    }

    private _rebuttalData = new BehaviorSubject<RebuttalInfo>(this.sessionStorage.getFromJson(OX_KEYS.REBUTTAL_DATA) || {});
    public rebuttalData$ = this._rebuttalData.asObservable();

    get rebuttalData() {
        return this._rebuttalData.getValue();
    }

    set rebuttalData(val: Partial<RebuttalInfo>) {
        const r = this.rebuttalData;
        if (val.page) r.page = val.page;
        if (val.offeringId) r.offeringId = val.offeringId;
        if (val.cancelOrderNumbers) r.cancelOrderNumbers = val.cancelOrderNumbers;
        this.sessionStorage.setAsJson(OX_KEYS.REBUTTAL_DATA, r);
        this._rebuttalData.next(r as RebuttalInfo);
    }

    private _upcomingPlan = new BehaviorSubject<string>('');
    public upcomingPlan$ = this._upcomingPlan.asObservable();
    
    set upcomingPlan(val: string) {
        this._upcomingPlan.next(val);
    }

    resetRebuttal() {
        this.sessionStorage.remove(OX_KEYS.REBUTTAL_DATA);
        this._rebuttalData.next({} as RebuttalInfo);
    }

    init() {
        const {shop} = this.location.getState() as ShopState;
        if (shop?.billingType) this.billingType = shop.billingType;
        if (shop?.planCodes) this.planCodes = shop.planCodes;
    }
}
